import * as angular from 'angular';
import { fn, IInfOperation } from '@common/utils';
import { INavPageItemControl } from '@common/navkendo/navpageitems';
import resolveToError = fn.resolveToError;
import reorderForColumns = fn.reorderForColumns;
import { InfWindowService } from '@services/infwindowservice';
import { $ModalOpened, IDialogService } from '@common/services/DialogService';
import { DialogService } from '../services/dialogservice';
import { UseOverlay, CreateOverlay, IsKendoMobile } from '@common/navkendo';
import { InfSelectItem } from './multiselect.ctrl';

/** AutoFocus Utility directive */
var NavAutoFocus = ['$timeout', function ($timeout): ng.IDirective {
    return {
        restrict: 'A',
        link: function (_scope: ng.IScope, _element, _attr: ng.IAttributes & { navautofocus: any }) {
            var el = <HTMLInputElement>_element[0];
            function exec() {
                if (angular.isFunction(el.select))
                    el.select();
                if (angular.isFunction(el.focus))
                    el.focus();
            }
            if (el && _attr && _attr.navautofocus !== false && _attr.navautofocus !== "false") {
                // Trigger after Modal Open if Modal Scope
                if (_scope["_InfModalScope"]) {
                    var onOpen = _scope.$on($ModalOpened, () => {
                        onOpen();
                        exec();
                    });
                } else {
                    $timeout(exec);
                }
            }
        }
    };
}];

export interface IDimension {
    height: number;
    width: number;
}

/** Directive to Transfer UI Dimension in Scope Variables (WTF, still ugly) */
var infWatchDimension = ["$timeout", "InfWindowService", function ($timeout: ng.ITimeoutService, InfWindowService: InfWindowService): ng.IDirective {
    return {
        restrict: "A",
        scope: {
            infWatchElement: "=?",
            infWatchDimension: "=?",
            sizeChanged: "&",
            infWatchParent: "@",
            infWatchClosest: "@",
            contentOnly: "=?"
        },
        link: (
            scope: ng.IScope,
            instanceElement: ng.IAugmentedJQuery,
            instanceAttributes: ng.IAttributes,
            controller: any
        ) => {

            var el = instanceElement[0];
            var useContentDim = !!scope["contentOnly"];
            var currentDim: IDimension;
            var getCurrentDim = (el: HTMLElement) => {
                if (el) {
                    // Substract padding from dimension?
                    var paddingWidth = useContentDim ?
                        parseInt($(el).css("padding-left")) + parseInt($(el).css("padding-right")) : 0;
                    var paddingHeight = useContentDim ?
                        parseInt($(el).css("padding-top")) + parseInt($(el).css("padding-bottom")) : 0;
                    var contentHeight = el.clientHeight - paddingHeight;
                    var contentWidth = el.clientWidth - paddingWidth;

                    if (!currentDim || (contentHeight != currentDim.height || contentWidth != currentDim.width)) {
                        currentDim = scope["infWatchDimension"] = { height: contentHeight, width: contentWidth };
                    }
                }
                return currentDim;
            };
            // Problem : Modal will get attached later!
            $timeout(() => {
                var expr;
                if (expr = scope.$eval(scope["infWatchClosest"]))
                    el = $($(el).closest(expr))[0];

                var watchParent = scope.$eval(scope["infWatchParent"]) === true;
                if (watchParent)
                    el = el.parentElement;
                var sizeChanged = scope["sizeChanged"];

                InfWindowService.RegisterResizeChanged(() => {
                    getCurrentDim(el);
                }, $(el), scope);
                if (el && el.clientHeight !== undefined && sizeChanged) {
                    scope["infWatchElement"] = el;
                    var triggerChange = fn.debounce(sizeChanged, 25);

                    scope.$on("$destroy", <any>scope.$watch((s) => getCurrentDim(el), triggerChange));
                }
            });
        }
    };
}];

//#region Custom Interfaces

export function ExecuteOperation(op: IInfOperation, DialogService: IDialogService, scope?: ng.IScope, boundTo?: string) {
    try {
        var opWrap = (start: boolean) => {
            if (op) {
                op.IsRunning = start;
            }
            if (scope) {
                scope.$emit("InfOperation" + (start ? "Start" : "End"), op);
            }
        };
        if (!op) {
            opWrap(true);
            return DialogService.ShowError("Aktion '" + boundTo || "<unbekannt>" + "' nicht gebunden!")
                .then(() => opWrap(false), err => { opWrap(false); throw err; });
        }
        else if (op.Enabled == false)
            return; // Don't allow actions on disabled items
        else {
            var promise = op.Execute();
            if (fn.isPromise(promise)) {
                promise.then(() => { opWrap(false); }, () => { opWrap(false); });
                opWrap(true);

                promise.then(undefined, err => {
                    DialogService.ShowError(err);
                });
            } else {
                if (scope && !scope.$root.$$phase) {
                    scope.$apply();
                }
            }
        }
    } catch (exc) {
        DialogService.ShowError(exc);
    }
}
/** Directive to bind an Operation to a UI Control */
var infOperation = ["DialogService", function (DialogService: DialogService) {
    return <ng.IDirective>{
        scope: {
            infOperation: "=infOperation",
            infOperationOptions: "=infOperationOptions"
        },
        link: (scope: ng.IScope,
            instanceElement: ng.IAugmentedJQuery,
            instanceAttributes: ng.IAttributes) => {
            var boundTo = instanceAttributes["infOperation"] || "<unbekannt>";

            var options: { Hidden: any };
            if (instanceAttributes["infOperationOptions"]) {
                scope.$watch("infOperationOptions", (newOptions: any) => {
                    options = newOptions;
                });
            };
            var currOperation = () => <IInfOperation>scope["infOperation"];
            // problem : handle 'touchstart' vs 'click' (if both triggerd: would double execute)
            var execute = fn.throttle(() =>
                ExecuteOperation(currOperation(), DialogService, scope, boundTo)
            , 100, true, false);
            /** Check if Element is part of a Kendo Context Menu and Execute action if it is */
            var actIfContextMenu = (el: JQuery, cmCallBack: (cm: kendo.ui.ContextMenu) => void) => {
              var check: JQuery;
              check = el.parents().filter(function () {
                return $(this).data("kendoContextMenu") !== undefined;
              });
                if (check && check.length > 0) {
                    var cm = <kendo.ui.ContextMenu>check.data("kendoContextMenu");
                    cmCallBack(cm);
                    return true;
                };
                return false;
            };

            /** bind to button (--> ) */
            function bindToButton(el: JQuery) {
                var hiddenIsEnabled = false;
                var setEnabled = (newVal: boolean) => {
                    if (typeof newVal == "boolean") {
                        if (!actIfContextMenu(el, cm => cm.enable(el, newVal))) {
                            if (el.data("kendoButton") || el.data("kendoMobileButton") || el.hasClass("k-button") || ["menuitem", "button"].indexOf(el.attr("role")) >= 0 ||
                                (["a", "li"].indexOf((el[0] && el[0].tagName.toLowerCase())) >= 0))
                                $(el).toggleClass("k-state-disabled", !newVal);
                            newVal ? $(el).removeAttr("disabled") : $(el).attr("disabled", "disabled");
                            if (newVal)
                                $(el).removeClass("k-state-disabled km-state-disabled");
                        }
                        if (hiddenIsEnabled)
                            setHidden(!newVal);
                    }
                };
                var setHidden = (isHidden) => {
                    if (typeof isHidden == "boolean") {
                        var op = currOperation();
                        // TODO : REFACTOR!!! : Defer functionality after End Of Running Op
                        // To Prevent Hide button during
                        if (op && op.IsRunning === true) {
                            var x = scope.$watch(() => op.IsRunning === false || undefined, (vFinished) => {
                                if (vFinished) {
                                    x();
                                    setEnabled(op.Enabled);
                                }
                            });
                            return;
                        }
                        isHidden ? $(el).hide() : $(el).show();
                    }
                };

                var setChecked = (isChecked) => {
                    // TODO PHWO : Handle Checked State (classes ...)
                    if (typeof (isChecked) == "boolean") {
                        el.addClass("fluent-tool-check-button");
                        isChecked ? el.addClass("fluent-tool-button-checked") : el.removeClass("fluent-tool-button-checked");
                    } else {
                        el.removeClass("fluent-tool-check-button");
                    }
                };

                scope.$on("destroy", <any>scope.$watch("infOperation.Enabled && !infOperation.IsRunning", setEnabled));
                scope.$on("destroy", <any>scope.$watch("infOperation.Hidden", (isHidden, oldVal) => {
                    // Prefer explict config from Usage over actoin's config for HiddenIsEnabled
                    hiddenIsEnabled = (options && "Hidden" in options) ? (options.Hidden == "Enabled") : (isHidden == "Enabled");
                    if (hiddenIsEnabled) {
                        var op = currOperation();
                        if (op)
                            setEnabled(op.Enabled);
                    } else {
                        setHidden(isHidden);
                    }
                }));
                scope.$on("$destroy", <any>scope.$watch<boolean>("infOperation.Checked", (newVal, oldVal) => setChecked(newVal)));

                el.on("mousedown", (e) => e.preventDefault())
                    .on("click touchstart", execute);
                scope.$on("$destroy", () => el.off("click touchstart", execute));
            }

            // TODO : Determine Control Type and bind differently for others?
            bindToButton(instanceElement);
        }
    };
}];

/** Directive to overlay Element with a busyindicator bound to a variable */
var infProgress = [function (): ng.IDirective {
    return <ng.IDirective>{
        link: (scope: ng.IScope,
            instanceElement: ng.IAugmentedJQuery,
            instanceAttributes: ng.IAttributes) => {
            var formula = instanceAttributes["infProgress"];
            if (formula) {
                scope.$watch<boolean>(formula, (newValue) =>
                    instanceElement.kendoNavBusyIndicator(!!newValue));
            }
        }
    };
}];

/** Directive to Display Textual Info : (if in Form of muliple Lines Label:Text display in "property grid" manner */
var infInfoDisplay = [function (): ng.IDirective {
    return {
        scope: {
            info: "=info",
            propagateto: "=propagateto",
        },
        link: (scope, element, attributes) => {
            var numCols = 2,
                dockProps: string[] = scope.$eval(attributes["propagateprops"]) || [],
                resetDockProps = fn.noop,
                inColDirection = true;
            scope.$watch<string | { Title: string, Value: string }[]>("info", (newValue) => {
                if (typeof newValue === "string") {
                    var resValue = (newValue || "").split("\n").filter(fn.isSet).map(item => {
                        var c = (item || "").split(":");
                        if (c.length > 1) {
                            return {
                                Title: (c[0] || "").trim(),
                                Value: c.slice(1).join(":").trim()
                            };
                        }
                    });
                } else {
                    resValue = newValue;
                }
                element.children().remove();
                element.text("");
                resetDockProps();

                if (resValue && resValue.length > 1 && resValue.every(fn.isSet)) {
                    if (inColDirection) {
                        resValue = reorderForColumns(resValue, numCols);
                    }

                    const gridFactory = IsKendoMobile() ? createPropertyGridMobile : createPropertyGrid;
                    gridFactory(resValue);

                    //let dock = scope["propagateto"];
                    scope.$watch(() => scope["propagateto"], (dock) => {
                        resetDockProps();
                        resetDockProps = fn.noop;
                        if (dock) {
                            resetDockProps = AddPropagated(dock, dockProps.map(d => fn.FindFirst(resValue, i => i.Title == d)));
                        }
                    });
                }
                else {
                    element.text((newValue && JSON.stringify(newValue)) || "");
                }
            });

            function createPropertyGrid(this: void, navRawValues: Array<{ Title: string, Value: string }>) {
                try {
                    // Add padding to table
                    element.addClass("idms_Panel_Padding");

                    let currRow: JQuery;
                    var table = $("<table class='navTable'></table>");
                    navRawValues.forEach((c, idx) => {
                        if (!(idx % numCols)) {
                            currRow = $('<tr>');
                            table.append(currRow);
                        } else {
                            // Add separator col
                            currRow.append($('<td class="navSepCell"></td>'));
                        }
                        var input = $("<input type='text' class='k-input k-textbox' />").addClass("k-state-disabled")
                            .attr("disabled", "disabled").val(c.Value).attr("title", c.Value);

                        var result = {
                            ValueCell: $('<td class="navValCell">'),
                            LabelCell: $('<td class="navLblCell">')
                        };
                        if (c.Title || c.Value) {
                            // assumption : mimic align "Currency Values" ...
                            if (c.Value && c.Value.match(/^\-?([0-9]{1,3})(\.[0-9]{3})*(\,[0-9]{1,2})?( \€)?$/))
                                input.css("padding-right", "5px").css("text-align", "right");
                            result.ValueCell.append(input);
                            result.LabelCell.text(c.Title);
                        } else {

                        }
                        currRow.append(result.LabelCell, result.ValueCell);
                    });

                    $(element).append(table);
                } catch (err) {
                    element.append($("<div>").text(resolveToError(err)));
                }
            }

            function createPropertyGridMobile(this: void, navRawValues: Array<{ Title: string, Value: string }>) {
                try {

                    let currNavLabelRow: JQuery;
                    let currNavCtrlRow: JQuery;

                    var table = $("<table class='navMTable'></table>");
                    let rowInfos: { Items: JQuery[] }[] = [],
                        currRowInfo: { Items: JQuery[] };
                    var navOrderValues = navRawValues.map((item, idx) => {
                        return {
                            Idx: idx,
                            Title: item.Title,
                            Element: $("<input type='text' class='k-input k-textbox' />").addClass("k-state-disabled")
                                .attr("disabled", "disabled").val(item.Value).attr("title", item.Value),
                        };
                    });

                    navOrderValues.forEach((c, idx) => {
                        if (!(idx % numCols)) {
                            currNavLabelRow = $(`<tr class="navMLabelRow">`);
                            currNavCtrlRow = $(`<tr class="navMCtrlRow">`);
                            let currCount = Math.min(numCols, navRawValues.length - idx);
                            let sepRow = $(`<tr class="navMSepRow"><td colspan="${currCount}"></td></tr>`);
                            currRowInfo = { Items: [sepRow, currNavCtrlRow, currNavLabelRow] };
                            rowInfos.push(currRowInfo);
                            table.append(currNavLabelRow, currNavCtrlRow, sepRow);
                        }
                        var result = {
                            ValueCell: $('<td class="">').append(c.Element),
                            LabelCell: $(`<td></td>`).append($('<label></label>').text(c.Title)),
                            Visible: true,
                        };
                        result.LabelCell.appendTo(currNavLabelRow);
                        result.ValueCell.appendTo(currNavCtrlRow);
                        c.Element.addClass("navMValue");
                        return result;
                    });

                    $(element).append(table);
                } catch (err) {
                    element.append($("<div>").text(resolveToError(err)));
                }
            }

            function AddPropagated(propTarget: INavPageItemControl, infos: Array<{ Title: string, Value: string }>) {

                var func = propTarget && propTarget.PropagateProperties;
                if (typeof func != "function")
                    return fn.noop;

                return propTarget.PropagateProperties(infos) || fn.noop;
            }
        }
    };
}];
//#endregion

/** Directive to Register an Event
 * - no isolated scope:
 * - infRegisterEvent='[jquery selector for elements on which to react]'
 *  infEventName='[eventname for registration]'
 * - infEventAction : event to call, original event gets provided as "infEvent"
 * e.g : <div kendo-grid nav-register-event="tr.k-state-selected" nav-event-name="dblclick" nav-event-action="selectAction(infEvent)">
 * with 'selectAction' being the action on scope to call
  */
var infRegisterEvent = ["$parse", function ($parse: ng.IParseService): ng.IDirective {
    return <ng.IDirective>{
        restrict: "A",
        scope: false,
        link: (
            scope: ng.IScope,
            instanceElement: ng.IAugmentedJQuery,
            instanceAttributes: ng.IAttributes) => {
            var selector = instanceAttributes["infRegisterEvent"];
            var eventName = instanceAttributes["infEventName"];
            var externalAction = instanceAttributes["infEventAction"];
            if (eventName && selector) {
                var functionCall = $parse(externalAction);
                var action = (event) => {
                    var locals = angular.extend({}, scope, { infEvent: event });
                    functionCall(scope, locals);
                    // We must appl as executiong outside of angular
                    if (!scope.$root.$$phase) {
                        scope.$apply();
                    }
                };
                instanceElement.on(eventName, selector, action);
                scope.$on('$destroy', () => instanceElement.off(eventName, action));
            }
        }
    };
}];

//#region  Controls

//#endregion

//#endregion

/** SetUp Toggle Toolbar State functionality and return Action */
export function SetUpToggleToolbar() {

    var executeSetHover: (check: boolean) => any;
    /** */
    function Initialize(bar: JQuery, barContent: JQuery, initState?: boolean | PromiseLike<boolean>) {

        executeSetHover = setHover;
        actHover.Enabled = true;
        var minHeight = bar.find(".tabs-holder").outerHeight(true),
            useOverlay = UseOverlay(),
            barOverlay,
            contentParent = barContent.parent(),
            detachedContentContainer = $('<div class="metro" style="position: absolute; width: 100%; background: white; z-index: 10000;"></div>'),
            detachedContentTarget = $('<div class="fluent-menu"></div>');

        detachedContentContainer.append(detachedContentTarget);
        var watchElements = bar.add(detachedContentContainer);
        const postfix = ".navtbsb";
        var mouseHit = false;
        function refresh(newState?: boolean, timeout?: number) {
            if (newState !== undefined)
                mouseHit = newState;

            if (timeout > 0) {
                // Defer if desired
                window.setTimeout(fn.proxy(refresh, null), timeout);
                return;
            }

            if (mouseHit) {
                setContentVisibility(true);
            }
            else if (opCounter <= 0) {
                setContentVisibility(false);
            }
        }

        function setContentVisibility(isVisible: boolean) {
            if (isVisible) {
                if (barOverlay) { barOverlay.Show(); }
                var topPos = bar.offset().top + bar.outerHeight(true);
                detachedContentContainer.css("top", topPos + "px");
                detachedContentContainer.show();
            } else {
                detachedContentContainer.hide();
                if (barOverlay) { barOverlay.Hide(); }
            }
        }

        function attachContent(attach: boolean) {
            if (attach) {
                contentParent.append(barContent);
            } else {
                detachedContentTarget.append(barContent);
                $(document.body).append(detachedContentContainer);
                if (useOverlay)
                    barOverlay = barOverlay || CreateOverlay(detachedContentContainer, { Height: 20 });
            }
        }

        function reset() {
            watchElements.off(postfix);
            if (barOverlay) {
                barOverlay.Hide();
            }
        }
        function setHover(hover) {
            reset();

            if (hover) {
                attachContent(false);

                refresh($(":hover", watchElements).length > 0); // keep showing if mouse over ...
                var ddOpen = false;
                // Hack : DropDown Open triggers mouse leave, so we have to handle it seperately
                watchElements.on("InfDropDownOpen" + postfix, () => ddOpen = true);
                watchElements.on("InfDropDownClose" + postfix, () => {
                    ddOpen = false;
                    if ($(":hover", watchElements).length == 0) {
                        refresh(false, 500);
                    }
                });

                watchElements.on("mouseenter" + postfix, fn.proxy(refresh, this, true, 80));
                watchElements.on("mouseleave" + postfix, (e) => {
                    if (!ddOpen)
                        refresh(false, 500);
                });
            } else {
                attachContent(true);
                refresh(true);
            }

            // Emulate hover by limiting the container height
            bar.css("max-height", hover ? minHeight : "none");
            barContent.toggleClass("idms_BottomShadow", hover);
        }
        /** Marker for currently Running Operations, to prevent hiding toolbar during a running Operation */
        var opCounter = 0;
        function notifyOperation(start: boolean) {
            var curr = start ? ++opCounter : --opCounter;
            if (curr == 0 && actHover.Checked)
                window.setTimeout(() => { if (!mouseHit) refresh(); }, 1000);
        }

        let ngJq = angular.element(bar);
        let $scope = ngJq.scope();
        if ($scope) {
            // Do not Hide Toolbar during a running Operation
            $scope.$on("InfOperationStart", fn.proxy(notifyOperation, this, true));
            $scope.$on("InfOperationEnd", fn.proxy(notifyOperation, this, false));

            $scope.$on("$destroy", () => { reset(); detachedContentContainer.remove(); });

            if (initState !== undefined) {
                let $q: ng.IQService = ngJq.injector().get("$q");
                $q.when(initState).then(c => {
                    setHover(actHover.Checked = c);
                });
            } else {
                setHover(actHover.Checked);
            }
        }
    }
    var actHover = {
        Enabled: false,
        Execute: () => executeSetHover(actHover.Checked = !actHover.Checked),
        Checked: false,
        Initialize: Initialize
    };
    return actHover;
}

/** Utiltity to  meke the Metro Menu Used in EditForm / Admin more "Reponsive" ( TODO : Bring into  standard editForm? */
namespace MetroMenu {
    const InfMetroMenuChange = "InfMetroMenuChange";
    const Threshold_Large = "Large";

    class InfMetroMenuController {
        static $inject = ["$scope"];
        constructor(private $scope: ng.IScope) { }

        public OnResize() {
            var changed = false,
                outerWidth = this.Menu && this.Menu.outerWidth();
            fn.DictToArray(this.Thresholds).forEach(item => {
                if (item.Threshold > 0 && outerWidth >= 0) {
                    var newCheck = outerWidth > item.Threshold;
                    if (newCheck !== item.Check) {
                        item.Check = newCheck;
                        changed = true;
                    }
                }
            });
            if (changed) {
                this.$scope.$broadcast(InfMetroMenuChange);
            }

            return changed;
        }

        /** Check for Named Threshold Exceeds */
        public ExceedsThreshold(name: string, defaultValue: boolean) {
            var t = this.Thresholds[name];
            return t ? t.Check : defaultValue;
        }

        /** Set/ Add Named Thresholds */
        public SetThresholds(thresholds: any) {

            for (var name in this.Thresholds)
                delete this.Thresholds[name];

            for (name in thresholds || {}) {
                var val = parseInt(thresholds[name]);
                if (val > 0)
                    this.Thresholds[name] = {
                        Check: <boolean>undefined,
                        Threshold: val
                    };
            }
            this.OnResize();
        }

        /** Named Thresholds */
        public Thresholds: {
            [name: string]: {
                Threshold: number,
                Check: boolean,
            }
        } = {};

        public Menu: JQuery;
    }

    interface IInfMenuOptions { Thresholds: { [name: string]: number }; }

    /** Metro Menu Directive */
    var InfMetroMenu = [function InfMetroMenu(): ng.IDirective {
        return {
            controller: InfMetroMenuController,
            link: (scope: ng.IScope, el: ng.IAugmentedJQuery, attr: ng.IAttributes, controller: InfMetroMenuController) => {
                controller.Menu = el;
                $(window).on("resize.InfMetroMenu", () => {
                    if (controller.OnResize()) {
                        scope.$applyAsync();
                    }
                });
                scope.$on("$destroy", () => $(window).off(".InfMetroMenu"));

                // setup Thresholds
                attr.$observe("infThresholds", (thresholds: any) => {
                    thresholds = scope.$eval(thresholds);
                    controller.SetThresholds(thresholds);
                });
            }
        };
    }];

    /** Metro Menu Button Directive
    /* inf-icon="[NameOfIcon]" inf-title="[titleifdislayed]" inf-style="['notitle', 'small']"
     */
    var InfMetroButton = [function InfMetroButton(): ng.IDirective {
        return {
            require: "^^infMetroMenu",
            link: (scope: ng.IScope, el: ng.IAugmentedJQuery, attr: ng.IAttributes, controller: InfMetroMenuController) => {
                var icon = $("<img />"),
                    text = $("<span></span>"),
                    iconName = "Add",
                    iconTitle = "",
                    explicitStyle = "", // 'notitle', 'small'
                    hasExplicit = (n: string) => explicitStyle.indexOf(n) >= 0,
                    getIsSmall = () => hasExplicit("small") || !controller.ExceedsThreshold(Threshold_Large, true);

                el.prepend(text).prepend(icon);

                scope.$on(InfMetroMenuChange, infIcon.bind(null, undefined));

                function infIcon(name?: string) {
                    iconName = name || iconName;
                    icon.attr("src", "./icons/" + iconName + (getIsSmall() ? "Small" : "") + ".png");
                    var calcSmall = !!getIsSmall();
                    el.toggleClass("fluent-button", calcSmall).toggleClass("fluent-big-button", !calcSmall);
                    text.toggle(!(calcSmall || hasExplicit("notitle")));
                }
                function infTitle(title: string) {
                    iconTitle = title || iconTitle;
                    text.text(iconTitle);
                }
                function infStyle(s: string) {
                    explicitStyle = ("" + s).toLocaleLowerCase();
                    infIcon();
                }

                attr.$observe("infIcon", infIcon);
                attr.$observe("infTitle", infTitle);
                attr.$observe("infStyle", infStyle);
            }
        };
    }];

    angular.module("infoma.angularEx.metro", [])
        .directive("infMetroButton", InfMetroButton)
        .directive("infMetroMenu", InfMetroMenu);
}

// $.busyIndicator
(function ($: JQueryStatic) {
    if (!$)
        return;

    $.extend($.fn, {
        kendoNavBusyIndicator: function (show: boolean | PromiseLike<any>) {
            var me = <JQuery><any>$(this);

            if (fn.isPromise(show)) {
                const hide = () => { me.kendoNavBusyIndicator(false); };
                show.then(hide, hide);
                return me.kendoNavBusyIndicator(true);
            } else {
                var loadingMask = me.find(".k-loading-mask");
                if (show) {
                    if (!loadingMask.length) {
                        loadingMask = $("<div class='k-loading-mask'><span class='k-loading-text'>Lade...</span><div class='k-loading-image'/><div class='k-loading-color'/></div>").width(me.width()).height(me.height()).prependTo(me);
                    }
                } else {
                    loadingMask.remove();
                }
                // TODO: Watch for size change and adapt
                return me;
            }
        },
    });
})(window['$']);

angular.module("infoma.angularEx", ["infoma.angularEx.metro"])
    .directive("infRegisterEvent", infRegisterEvent)
    .directive("infOperation", infOperation)
    .directive("infProgress", infProgress)
    .directive("infInfoDisplay", infInfoDisplay)
    .service("InfWindowService", InfWindowService)
    .directive("infWatchDimension", infWatchDimension)
    .directive('navautofocus', NavAutoFocus)
    .directive("infSelectItem", InfSelectItem);

declare global {

    interface JQuery {
        /** Custom Busy Indicator Implementation (see kendo.ui.progress, default imp seems to be shown on whole page, not parts ) */
        kendoNavBusyIndicator(value: boolean | PromiseLike<any>): JQuery;
    }
}
